











import Vue from 'vue'
import Postmate from 'postmate'
import config from '../../../config'
import { AuthUser, Location, Company, User } from '../../../models'
import store from '../../../store'
import { UserState } from '@/store/state_models'
import firebase from 'firebase/compat/app'
import { mapState } from 'vuex'

const setElementDisplay = (
  element: HTMLElement | null,
  displayValue: string,
  isMounted = true
) => {
  try {
    if (element) {
      if (element.hasAttribute('data-tags-display')) {
        element.removeAttribute('data-tags-display')
        return
      }
      const computedStyle = window.getComputedStyle(element)
      if (
        isMounted &&
        (element.style?.display === displayValue ||
          computedStyle?.display === displayValue)
      )
        element.setAttribute('data-tags-display', displayValue)
      else element.style.display = displayValue
    }
  } catch (err) {
    console.warn(err, '')
  }
}

const hasFirstFixedElements = function (element: Element, checkChildren = true): boolean {
  let child = element && element.children
  if (element.id !== 'app' && child && child.length > 0) {
    if (window.getComputedStyle(child[0]).position === 'fixed')
      return true
    if (checkChildren) {
      return hasFirstFixedElements(child[0], checkChildren)
    }
  }
  return false
}

export default Vue.extend({

  watch: {
    '$route.params.location_id': async function(id) {
      this.locationId = id
      await this.childApp.then((child: any) => {
      child.destroy()
      this.childApp = undefined
    })
      this.loadMicroApp()
    }
  },
  mounted() {
    this.loadMicroApp()
    this.previousSideBarState = this.$store.getters.getManualCollapseSidebar
    if (!this.isV2SideBarEnable)
      this.$store.commit('setManualCollapseSidebar', true)
    this.toggelCustomJsVisibility('none')
  },
  computed: {
    ...mapState('user', {
      user: (s: UserState) => {
        return s.user ? new User(s.user) : undefined
      },
    }),
    locationId() {
      return this.$route.params.locationId
    },
    location() {
      const locations = this.$store.state.locations.locations
      return locations.find(
        (x: { [key: string]: any }) => x.id === this.$route.params.location_id
      )
    },
    company() {
      return this.$store.state.company?.company
    },
    isV2SideBarEnable() {
      return this.$store.getters['sidebarv2/getVersion'] == 'v2'
    },


    isAgencyAdmin() {
      if (this.user && this.user.role === 'admin' && this.user.type === 'agency') {
        return true;
      } else {
        return false;
      }
    }
  },
  beforeDestroy() {
    this.childApp.then((child: any) => {
      child.destroy()
      this.childApp = undefined
    }) // closing the child connection
    if (!this.isV2SideBarEnable)
      this.$store.commit('setManualCollapseSidebar', this.previousSideBarState)
    this.toggelCustomJsVisibility('inline', false)
  },
  async created() {

  },
  data: () => {
    return {
      locations: [] as Location[],
      childApp: undefined as any,
      previousSideBarState: undefined as boolean | undefined,
      showSmtpWarning: false,
      requestCardLocationId: '',
      showRequestCardModal: false,
      requestCardSuccessMessage: '',
      showManageLocationSubscriptionModal: false,
      showRequestCardSuccessModal: false,
      teamMemberModalValues: {},
      loadingLocationsCount: false,
      showUpgradeModal: false,
      loadSnapshotTemplateModal: { visible: false } as { [key: string]: any },
      deleteLocationAbortModalValues: { show: false },
      calendarProviders: {},
    }
  },

  methods: {
    toggelCustomJsVisibility(value: string, isMounted = true) {
      // agency custom js breaks workflow builder drag and drop feature
      // hide that DOM temprorly when user opens workflow builder

      // do not hide it in list page
      if (value === 'none' && this.$route.name === 'workflows') return

      for (let element of [
        'customJS',
        'freshworks-container',
        'beacon-container',
      ]) {
        const customJsEl = document.getElementById(element)
        setElementDisplay(customJsEl, value, isMounted)
      }

      //@ts-expect-error dom operation
      document.body.children.forEach(e => {
        const child = e.children
        if (e?.id?.includes('pendo')) {
          // Do nothing as this is from pendo
        } else if (
          window.getComputedStyle(e).position === 'fixed' ||
          hasFirstFixedElements(e, true)
        ) {
          setElementDisplay(e, value)
        }
      })
    },
    async getTokenId(): Promise<string> {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const tokenId = await firebase.auth().currentUser.getIdToken()
      return tokenId
    },
    switchToLocation(locationId: string) {
      this.$router.push({
        name: 'dashboard',
        params: { location_id: locationId },
      })
    },

    async setChildApp() {
    
      const linkUrl = config.triggerLinksAppUrl
      const tokenId = await this.getTokenId()
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      const userPermission = this.$store.state.user?.user?.permissions

      const user = {
        id: firebase.auth().currentUser?.uid,
        type: this.$store.state.user?.user?.type,
        role: this.$store.state.user?.user?.role,
        permission: {
          assigned_data_only: userPermission?.assigned_data_only,
          tags_enabled: userPermission?.tags_enabled
        },
        first_name: this.$store.state.user?.user?.first_name,
        last_name: this.$store.state.user?.user?.last_name,
        profile_photo: this.$store.state.user?.user?.profile_photo,
        email: this.$store.state.user?.user?.email,
        phone: this.$store.state.user?.user?.phone,
      }

      const handshake = new Postmate({
        container: this.$refs.triggerLinksPage,
        url: `${linkUrl}/v2/location/${this.$route.params.location_id}/links`,
        name: 'links-app',
        model: {
          locationId: this.$route.params.location_id,
          internalUser: this.$store.state.user?.internalUser || false,
          token: tokenId,
          authApiKey: auth.apiKey,
          timeZone: this.location?.timezone,
          companyId: this.$store.state.company?.company?.id,
          company: this.$store.state.company?.company,
          user,
          users: this.$store.state.users.users,
          campaigns: this.$store.state.campaigns.campaigns,
          currentLocation: this.$store.state.locations.currentLocation,
          isV2SideBarEnable: this.isV2SideBarEnable,
        },
      })

      handshake
        .then((child: any) => {
          
          child.on('route-change', (data: any) => {
            if (data.body.inNewPage) {
              let routeData = this.$router.resolve({
                path: data.body.path,
              })
              data.body.path.startsWith('https') || data.body.path.startsWith('http')  ? window.open(data.body.path, '_blank'): window.open(routeData.href, '_blank')
            } else {
              this.$router.push(data.body.path)
            }
          })
          child.on('refresh-token', async () => {
            const tokenId = await this.getTokenId()
            child.call('refresh-token', tokenId)
          })
          child.on('switch-to-location', async (data: any) => {
            this.switchToLocation(data.id)
          })
        })
        .catch(async (err: Error) => {

          console.error({ handledError: err })
          this.$refs.triggerLinksPage.innerHTML = ''
          await this.setChildApp()
        })
      this.childApp = handshake
    },

    async loadMicroApp() {
      await this.setChildApp()
    }
  },
})
